// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionTitle_root__l4KQa"};
    if(module.hot) {
      // 1586964020745
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  